import axios from 'axios';
import React, { useEffect, useState } from 'react';

// chonky (file browser)
import { ChonkyIconFA } from 'chonky-icon-fontawesome';
setChonkyDefaults({ iconComponent: ChonkyIconFA });
import {
  FullFileBrowser,
  ChonkyActions,
  setChonkyDefaults,
  defineFileAction,
  ChonkyIconName
} from 'chonky';

// mui
import Box from '@mui/material/Box';

// styles
import { useStyles } from "./styles";

// store
import { useRecoilValue } from 'recoil';
import { currentOrgId, currentUser } from '../../../../store';

// components
import PageTitle from '../../../../components/PageTitle';
import OrganisationService from '../../../../service/organisation-service';
import { delay, processPathsForChonky } from '../../../../utils/utils';
import CircularProgress from '@mui/material/CircularProgress';

const FileBrowserReport = () => {
  // state
  const user = useRecoilValue(currentUser);
  const orgId = useRecoilValue(currentOrgId);
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState('');

  const [selectedFileIds, setSelectedFileIds] = useState([]);

  const fetchAndFormatFiles = async () =>  {
    let files = await loadData();
    const path = user?.orgSettings.path.setting_value;
    const formattedFiles = processPathsForChonky(files, `${orgId}/${path}`);
    setFiles(formattedFiles);
  }

  // load data
  const loadData = async () => {
    try {
      setLoading(true);
      const { data } = await OrganisationService.reports.fileBrowser() ;
      return data;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // have to wait for settings to load, to get the initial path
  // so it can be filtered by Chonky
  useEffect(() => {
    if (!orgId) return;
    if (!user?.orgSettings?.path?.setting_value?.length > 0) {
      setLoading(false);
      return;
    }

    fetchAndFormatFiles();
  }, [user, orgId]);

  const handleFileAction = async (action) => {
    if (action.id === ChonkyActions.ChangeSelection.id) {
      setSelectedFileIds(Array.from(action.payload.selection));
      return;
    }

    if (action.id === DownloadFileAction.id) {
      const { data: signedUrls } = await OrganisationService.reports.fileBrowserGetSignedUrls(selectedFileIds);

    }
  };

  let fileBrowserSettings = user
    ?.userPermissions
    ?.find(m => m.module_id === 31);

  let title = "";
  if (!fileBrowserSettings)
    title = "File Browser Report";
  else if (fileBrowserSettings?.name_override?.length > 0)
    title = fileBrowserSettings?.name_override;
  else
    title = fileBrowserSettings?.name;

  const DownloadFileAction = defineFileAction({
    id: 'download_file',
    button: {
      name: 'Download',
      toolbar: true,
      contextMenu: true,
      icon: ChonkyIconName.download,
    },
  });

  const fileActions = selectedFileIds.length > 0 ? [DownloadFileAction] : [];

  return (
    <Box className={classes.mainWrap}>
      <PageTitle>
        { title }
      </PageTitle>
      <div style={{
        height: 400,
        width: '100%'
      }}>
        { loading && <CircularProgress />}
        { !loading && <FullFileBrowser
          files={files}
          fileActions={fileActions}
          defaultFileViewActionId={ChonkyActions.EnableListView.id}
          onFileAction={handleFileAction} />
        }
      </div>
    </Box>);
};

export default FileBrowserReport
